<template>
  <template v-for="(part, index) in parts" :key="index">
    <a
      v-if="part.href"
      :href="part.href"
      class="text-[hsl(var(--primary))] underline underline-offset-2 break-words"
      :target="part.href.startsWith('http') ? '_blank' : undefined"
      :rel="part.href.startsWith('http') ? 'noopener noreferrer' : undefined"
    >{{ part.text }}</a>
    <template v-else>{{ part.text }}</template>
  </template>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{ text: string }>();

interface InlinePart {
  text: string;
  href?: string;
}

const TOKEN_RE = /(https?:\/\/[^\s]+|[\w.+-]+@[\w.-]+\.[A-Za-z]{2,})/g;
const TRAILING_PUNCTUATION_RE = /[.,;:!?)]*$/;

const parts = computed<InlinePart[]>(() => {
  const result: InlinePart[] = [];
  let cursor = 0;
  for (const match of props.text.matchAll(TOKEN_RE)) {
    const start = match.index ?? 0;
    if (start > cursor) result.push({ text: props.text.slice(cursor, start) });

    const raw = match[0];
    const trailing = raw.match(TRAILING_PUNCTUATION_RE)?.[0] ?? "";
    const value = trailing ? raw.slice(0, -trailing.length) : raw;
    result.push({ text: value, href: value.startsWith("http") ? value : `mailto:${value}` });
    if (trailing) result.push({ text: trailing });
    cursor = start + raw.length;
  }
  if (cursor < props.text.length) result.push({ text: props.text.slice(cursor) });
  return result.length ? result : [{ text: props.text }];
});
</script>
